import React from "react";

function WelcomeExam() {
  return (
    <div className="mt-5 text-center">
      <h1>صفحة الاختبارات</h1>
      <h2>قم باختيار فصلك من اعلى</h2>
    </div>
  );
}

export default WelcomeExam;
